// extracted by mini-css-extract-plugin
export var assetList = "lcLQ7dI5aiugWf1L1yjG";
export var assetTable = "Qbep9TrFonTdX46Fk1xg";
export var skeleton = "fbjR4KJz2VjOgZ_eHeMG";
export var skeletonItem = "wYR_FGxFsU2FSSqwkJL0";